function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { shape, string } from 'prop-types';
import { SearchBar } from "../../general-widgets/SearchBar";
import { Header } from "../Header";
import { FlexContainer } from "../../layout/FlexContainer";
import { Grid } from "../../layout/Grid";
import { GridRow } from "../../layout/GridRow";
import { Slideshow } from "../../media/Slideshow";
import { Heading } from "../../typography/Heading";
import { ShowOn } from "../../layout/ShowOn";
export var Component = function Component(_ref) {
  var headingText = _ref.headingText,
      headerProps = _ref.headerProps,
      searchBarProps = _ref.searchBarProps,
      slideshowProps = _ref.slideshowProps;
  return React.createElement(FlexContainer, null, React.createElement("div", {
    className: "slideshow-hero"
  }, React.createElement(Header, headerProps), React.createElement("div", {
    className: "slideshow-content-container"
  }, React.createElement(Slideshow, _extends({}, slideshowProps, {
    isFluid: true,
    isShowingBulletNavigation: false,
    willFill: true
  })), React.createElement("div", {
    className: "content-container"
  }, React.createElement(ShowOn, {
    computer: true,
    parent: Heading,
    parentProps: {
      isColorInverted: true,
      size: 'huge',
      textAlign: 'center'
    },
    tablet: true,
    widescreen: true
  }, headingText), React.createElement(ShowOn, {
    mobile: true,
    parent: Heading,
    parentProps: {
      isColorInverted: true,
      size: 'large',
      textAlign: 'center'
    }
  }, headingText), React.createElement(Grid, {
    areColumnsCentered: true
  }, React.createElement(GridRow, {
    horizontalAlignContent: "center"
  }, React.createElement(ShowOn, {
    computer: true,
    parent: SearchBar,
    parentProps: _objectSpread(_objectSpread({}, searchBarProps), {}, {
      willLocationDropdownOpenAbove: true,
      isCalendarIconDisplayed: false
    }),
    tablet: true,
    widescreen: true
  }), React.createElement(ShowOn, {
    mobile: true
  }, React.createElement(SearchBar, _extends({}, searchBarProps, {
    isCalendarIconDisplayed: false,
    isDisplayedAsModal: true
  })))))))));
};
Component.displayName = 'SlideshowHero';
Component.defaultProps = {
  headingText: null,
  headerProps: {},
  searchBarProps: {},
  slideshowProps: {}
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  headerProps: shape(Header.propTypes),
  headingText: string,
  searchBarProps: shape(SearchBar.propTypes),
  slideshowProps: shape(Slideshow.propTypes)
} : {};